var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_459509)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1024_459509)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.2578,
    y: 8.46484,
    width: 36.4555,
    height: 45.3357,
    rx: 3.27562,
    transform: "rotate(13.4412 44.2578 8.46484)",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5664,
    y: 50.3301,
    width: 35.6224,
    height: 4.51783,
    rx: 2.25891,
    transform: "rotate(13.4412 48.5664 50.3301)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1328,
    y: 60.0645,
    width: 24.1577,
    height: 2.5099,
    rx: 1.25495,
    transform: "rotate(13.4412 52.1328 60.0645)",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.3594,
    y: 10.7559,
    width: 36.4555,
    height: 45.3357,
    rx: 3.27562,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78339 32.2397L11.7042 41.2864L29.5773 10.3293L20.7822 13.1892C19.8433 13.4409 18.6417 14.1473 18.2168 14.8832L9.96768 29.171C9.41774 30.1235 9.53192 31.3008 9.78339 32.2397Z",
    fill: "#CFCFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54853 50.2163L11.7042 41.2864M33.3581 3.78072L29.5773 10.3293M11.7042 41.2864L9.78339 32.2397C9.53192 31.3008 9.41774 30.1235 9.96768 29.171C10.5176 28.2185 15.6963 19.2489 18.2168 14.8832C18.6417 14.1473 19.8433 13.4409 20.7822 13.1892L29.5773 10.3293M11.7042 41.2864L29.5773 10.3293",
    stroke: "#CFCFD2",
    strokeWidth: 2.14286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78339 32.2397L11.7042 41.2864L29.5773 10.3293L20.7822 13.1892C19.8433 13.4409 18.6417 14.1473 18.2168 14.8832L9.96768 29.171C9.41774 30.1235 9.53192 31.3008 9.78339 32.2397Z",
    fill: "#CFCFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9447 90.2384L26.8281 37.8574H78.971C77.5988 54.8642 75.5405 88.1976 74.8544 90.9186C74.1684 93.6397 71.424 95.0003 69.3657 95.0003H35.0612C32.3168 95.0003 30.9447 92.9595 30.9447 90.2384Z",
    fill: "#CFCFD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_459509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1024_459509"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.2578,
    y: 8.46484,
    width: 36.4555,
    height: 45.3357,
    rx: 3.27562,
    transform: "rotate(13.4412 44.2578 8.46484)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.79d89dc19b6bd051a3786231120e36c6.svg";
export { ForwardRef as ReactComponent };